export const USER_ACTIONS = {
    FETCH_USER_REQUEST: 'FETCH_USER_REQUEST',
    FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
    FETCH_USER_FAILURE: 'FETCH_USER_FAILURE',
};

export const GENERAL_ACTIONS = {
    LIGHT_MODE: 'LIGHT_MODE',

};